import {
  MdApproval,
  MdCalendarToday,
  MdGroups,
  MdOutlineEventSeat,
  MdOutlineMoney,
  MdPerson,
  MdHistory,
  MdOutlineAssessment,
} from "react-icons/md";
import { CiClock2 } from "react-icons/ci";
import { BsCalendar2WeekFill } from "react-icons/bs";
import { MdManageHistory } from "react-icons/md";

export const ADMIN_TABS = [
  {
    id: 1,
    icon: <MdOutlineEventSeat color="#752938" size={20} />,
    title: "Seat Allocation",
    url: "/courses",
  },
  {
    id: 2,
    icon: <MdOutlineMoney color="#752938" size={20} />,
    title: "Training Cost",
    url: "/admin/training-cost",
  },
  {
    id: 3,
    icon: <MdHistory color="#752938" size={20} />,
    title: "Audit Trail",
    url: "/admin/audit-trail",
  },
  // {
  //   id: 4,
  //   icon: <MdOutlineAssessment color="#752938" size={20} />,
  //   title: "Reports",
  //   url: "/admin/reports",
  // },
];

export const MANAGER_TABS = [
  {
    id: 1,
    icon: <MdApproval color="#752938" size={20} />,
    title: "Manager Approvals",
    url: "/manager",
  },
];

export const MY_TEAM_TABS = [
  {
    id: 1,
    icon: <MdCalendarToday color="#752938" size={20} />,
    title: "Apply for team",
    url: "/manager/apply-for-team",
  },
  {
    id: 2,
    icon: <MdGroups color="#752938" size={20} />,
    title: "Team Applications",
    url: "/manager/team-applications",
  },
];

export const HR_TABS = [
  {
    id: 1,
    icon: <MdApproval color="#752938" size={20} />,
    title: "Priority Requests",
    url: "/hr/all-trainings",
  },
  {
    id: 2,
    icon: <MdPerson color="#752938" size={20} />,
    title: "User Applications",
    url: "/hr/user-applications",
  },
  {
    id: 3,
    icon: <MdApproval color="#752938" size={20} />,
    title: "HR Approvals",
    url: "/hr/hr-approvals",
  },
  {
    id: 4,
    icon: <MdOutlineEventSeat color="#752938" size={20} />,
    title: "Seat Allocation",
    url: "/hr/seat-allocations",
  },
  {
    id: 5,
    icon: <MdOutlineMoney color="#752938" size={20} />,
    title: "Training Cost",
    url: "/hr/training-costs",
  },
  {
    id: 6,
    icon: <MdHistory color="#752938" size={20} />,
    title: "Audit Trail",
    url: "/hr/audit-trail",
  },
  // {
  //   id: 7,
  //   icon: <MdOutlineAssessment color="#752938" size={20} />,
  //   title: "Reports",
  //   url: "/hr/reports",
  // },
];

export const LEARNER_TABS = [
  {
    id: 1,
    icon: <CiClock2 color="#752938" size={20} />,
    title: "Available Trainings",
    url: "/learner/available-trainings",
  },
  {
    id: 2,
    icon: <BsCalendar2WeekFill color="#752938" size={20} />,
    title: "Application Status",
    url: "/learner/applied-trainings",
  },
  {
    id: 3,
    icon: <MdManageHistory color="#752938" size={20} />,
    title: "My Training History",
    // url: "/learner/my-trainings-history",
    url: `https://www.orbicollege.com/legacy/lms/index.php%3Fr%3DmyActivities/index%26tab%3Dclassrooms`, //${process.env.REACT_APP_LEARNING_HISTORY}
  },
  // {
  //   id: 3,
  //   icon: <FaRegFolder color="#752938" size={20} />,
  //   title: "ADVANCED TRAININGS",
  //   url: "#",
  // },
];

export interface Tabs {
  id: number;
  icon: any;
  title: string;
  url: string;
}
